"use client";
//? Library Imports ------------------------------------------------------------>
import {
  Col,
  Row,
  Space,
  message,
  Skeleton,
  Typography,
  Pagination,
} from "antd";

import { useSelector } from "react-redux";
import { useState, useEffect, useCallback } from "react";
import Cookies from "js-cookie";

//? Assets --------------------------------------------------------------------->
import { BiSolidPencil } from "react-icons/bi";
import { ArrowLeftOutlined } from "@ant-design/icons";

//? Modules -------------------------------------------------------------------->
import WishlistCard from "./WishlistCard/WishlistCard";
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";
import AddToCartModal from "@/components/CheckoutPage/Modules/AddToCartModal/AddToCartModal";
import "./index.css";

//? Redux Reducers ------------------------------------------------------------->
import AccountStatus from "@/functions/Cookies/Cookies";
import MediaQueryHook from "@/hooks/useMediaQuery/MediaQueryHook";

//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;

export default function WishlistModule({
  // Loading,
  // WishList,
  WishlistDetail,
  fetchWishlistDetails,
  userAgent,
}) {
  const { isMobile, isDesktop } = userAgent;
  const {
    loggedIn,
    comverse_customer_id,
    comverse_customer_email,
    comverse_customer_token,
  } = AccountStatus();
  const defaultCurrencyFromCookies = Cookies.get("defaultCurrencyName");
  const defaultgeoLocationCountry = Cookies.get("geoLocation");
  const defaultCountryFromCookies = Cookies.get("defaultCountry");
  const defaultCurrencyIdFromCookies = Cookies.get("defaultCurrencyId");
  const [Loading, setLoading] = useState(false);
  const [ActivePage, setActivePage] = useState(2);
  const [WishlistData, setWishlistData] = useState({});
  const [WishlistProducts, setWishlistProducts] = useState([]);

  const [ProductDetail, setProductDetail] = useState();
  const [ProductIndex, setProductIndex] = useState();
  const [ViewEditProductModal, setViewEditProductModal] = useState(false);

  const StoreId = defaultCurrencyIdFromCookies;

  //? Functions ------------------------------------------------------------------>
  const fetchWishlistProducts = useCallback(async () => {
    if (!loggedIn) {
      return null;
    } else {
      try {
        const headers = {
          "Content-Type": "application/json",
        };

        if (comverse_customer_token) {
          headers.Authorization = comverse_customer_token;
        }

        const url = `${process.env.NEXT_PUBLIC_BACKEND}/storefront/wishlist_list?limit=6&page=1&storefront=${StoreId}`;

        const payload = {
          method: "GET",
          headers: headers,
        };

        const WishlistData = await fetch(url, payload);
        const Products = await WishlistData.json();

        if (!WishlistData.ok) {
          throw new Error("Wishlist API Failed!");
        }

        if (Products) {
          setWishlistData(Products);
          setWishlistProducts(Products?.results);
          setActivePage(2);
          setLoading(false);
          return Products;
        }
      } catch (error) {
        // message.error("Wishlist API Failed!");
        console.error("Error fetching data:", error.message);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        return null;
      }
    }
  }, [loggedIn, comverse_customer_token, StoreId]);

  const fetchMoreProducts = useCallback(async () => {
    if (!loggedIn) {
      return null;
    } else {
      try {
        const headers = {
          "Content-Type": "application/json",
        };

        if (comverse_customer_token) {
          headers.Authorization = comverse_customer_token;
        }

        const url = `${process.env.NEXT_PUBLIC_BACKEND}/storefront/wishlist_list?limit=6&page=${ActivePage}&storefront=${StoreId}`;

        const payload = {
          method: "GET",
          headers: headers,
        };

        const WishlistData = await fetch(url, payload);
        const Products = await WishlistData.json();

        if (!WishlistData.ok) {
          throw new Error("Wishlist API Failed!");
        }

        if (Products) {
          setWishlistData(Products);
          setWishlistProducts((prevProducts) => [
            ...prevProducts,
            ...Products?.results,
          ]);
          setActivePage((prevPage) => prevPage + 1);
          setLoading(false);
          return Products;
        }
      } catch (error) {
        // message.error("Wishlist API Failed!");
        console.error("Error fetching data:", error.message);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        return null;
      }
    }
  }, [loggedIn, comverse_customer_token, ActivePage, StoreId]);

  const removeProductFromWishlist = async (productId) => {
    if (loggedIn && comverse_customer_token) {
      try {
        // setLoading(true);
        const headers = {
          "Content-Type": "application/json",
        };
        if (comverse_customer_token) {
          headers.Authorization = comverse_customer_token;
        }

        const body = {
          storefront: StoreId,
        };

        const payload = {
          method: "DELETE",
          headers: headers,
          body: JSON.stringify(body),
        };

        const res = await fetch(
          process.env.NEXT_PUBLIC_BACKEND +
            `/storefront/remove_product_from_wishlist?product_id=${productId}`,
          payload
        );
        const data = await res.json();

        if (!res.ok) {
          // message.error("Failed to delete from Wishlist!");
          throw new Error("Api Failed!");
        } else {
          // setProductInWishList(false);
          message.success("Product Deleted from Wishlist!");
          setLoading(false);
          fetchWishlistProducts();
          return data;
        }
      } catch (error) {
        console.log("error", error);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } else {
      // setShowLoginModal(true);
    }
  };

  //? Life Cycles ---------------------------------------------------------------->
  useEffect(() => {
    if (loggedIn && comverse_customer_token) {
      fetchWishlistProducts();
    }
  }, [loggedIn, comverse_customer_token, fetchWishlistProducts]);

  return (
    <Col className="WishlistModule">
      <Col span={24} className="padding10">
        <Space size="middle" className="flexBetween width100">
          <Text className="font14Bold poppinsMedium">Wishlist</Text>
          {/* <DynamicButton
            name="Share Bag"
            className="shareBtn"
            icon={<BiSolidPencil />}
          /> */}
        </Space>
      </Col>

      <Col className="marginTop15">
        <Row className="gap10">
          {WishlistProducts?.length
            ? WishlistProducts?.map((wishlist, index) => {
                return (
                  <Col span={24} className="padding0" key={index}>
                    <WishlistCard
                      WishListProduct={wishlist}
                      setProductDetail={setProductDetail}
                      setViewEditProductModal={setViewEditProductModal}
                      removeProductFromWishlist={removeProductFromWishlist}
                    />
                  </Col>
                );
              })
            : null}
          {WishlistProducts?.length === 0 && (
            <div className="empty-wishlist-text">Wishlist Empty</div>
          )}
        </Row>
      </Col>

      {WishlistData?.next ? (
        <Col className="marginTop15">
          <DynamicButton
            name="Load More"
            className="loadMore"
            function={() => fetchMoreProducts()}
          />
        </Col>
      ) : null}

      <Col className="marginTop20 flexCenter" span={24}>
        <Pagination
          hideOnSinglePage
          defaultCurrent={1}
          defaultPageSize={6}
          total={WishlistDetail?.count}
          onChange={(pageNo) => fetchWishlistDetails(pageNo)}
        />
      </Col>

      {ViewEditProductModal ? (
        <AddToCartModal
          userAgent={userAgent}
          Loading={Loading}
          setLoading={setLoading}
          // ModalType={"Wishlist"}
          ProductIndex={ProductIndex}
          ProductDetail={ProductDetail}
          fetchWishlistProducts={fetchWishlistProducts}
          ViewEditProductModal={ViewEditProductModal}
          setViewEditProductModal={setViewEditProductModal}
        />
      ) : null}
    </Col>
  );
}
